import { Link } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
import { Button } from './ui/button';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

export default function ProductCard({ product }) {
  const { addToCart } = useCart();
  const { isAuthenticated } = useAuth();

  const handleAddToCart = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (!isAuthenticated) {
      toast.error('Ou dwe konekte pou ajoute nan panye');
      return;
    }

    try {
      await addToCart(product.id);
      toast.success(`${product.name} ajoute nan panye!`);
    } catch (error) {
      toast.error('Erè pandan ajoute nan panye');
    }
  };

  return (
    <Link 
      to={`/products/${product.id}`} 
      className="group product-card block"
      data-testid={`product-card-${product.id}`}
    >
      <div className="relative overflow-hidden bg-white aspect-square">
        <img 
          src={product.image_url} 
          alt={product.name}
          className="w-full h-full object-contain p-4 transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        {product.stock < 10 && product.stock > 0 && (
          <span className="absolute top-3 left-3 bg-mrc-orange text-white text-xs font-bold px-2 py-1">
            Dènye {product.stock}!
          </span>
        )}
        {product.stock === 0 && (
          <span className="absolute top-3 left-3 bg-red-600 text-white text-xs font-bold px-2 py-1">
            Pa disponib
          </span>
        )}
        <Button
          onClick={handleAddToCart}
          disabled={product.stock === 0}
          className="absolute bottom-3 right-3 bg-mrc-navy hover:bg-mrc-navy/90 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300"
          size="icon"
          data-testid={`add-to-cart-${product.id}`}
        >
          <ShoppingCart className="h-4 w-4" />
        </Button>
      </div>
      <div className="pt-4 space-y-1">
        <p className="text-xs text-muted-foreground uppercase tracking-wide">
          {product.category}
        </p>
        <h3 className="font-heading text-lg font-semibold text-mrc-black group-hover:text-mrc-navy transition-colors">
          {product.name}
        </h3>
        <p className="price text-lg font-bold text-mrc-navy">
          ${product.price.toFixed(2)}
        </p>
      </div>
    </Link>
  );
}
